import { IconButton, IconName } from '@optimus-web/core';
import { UserProfileResult } from '@mews-commander/data-access';
import { DataTestId, TextKey } from '@mews-commander/enums';
import { LocalizedText, useDialog } from '@mews/framework';
import { useIsUserProvisioned } from '../../hooks/useIsUserProvisioned';
import { useTableActionsInfo } from '../../hooks/useTableActionsInfo';
import { TooltipWrapper } from '../TooltipWrapper';
import { DeleteUserDialog } from './DeleteUserDialog';

export const DeleteUserButton = ({
    userProfile,
    onSuccess,
}: {
    userProfile: UserProfileResult;
    onSuccess?: () => void;
}) => {
    const { isActionDisabled, isOwnProfile } = useTableActionsInfo(userProfile);
    const isUserProvisioned = useIsUserProvisioned(userProfile);
    const [deleteUserDialogProps, toggleDeleteUserDialog] = useDialog();

    const disabledDeleteTooltip = () => {
        if (isUserProvisioned) {
            return <LocalizedText textKey={TextKey.RoleDeleteProvisionedUserTooltip} />;
        }
        if (isOwnProfile) {
            return <LocalizedText textKey={TextKey.UserManagementCannotRemoveOwnProfileTooltip} />;
        }
        return <LocalizedText textKey={TextKey.UserManagementCannotRemoveAdminTooltip} />;
    };

    return (
        <>
            <TooltipWrapper active={isActionDisabled || isUserProvisioned} tooltip={disabledDeleteTooltip()}>
                <IconButton
                    variant="tertiary"
                    size="small"
                    icon={IconName.Delete}
                    onClick={toggleDeleteUserDialog}
                    disabled={isActionDisabled || isUserProvisioned}
                    data-test-id={DataTestId.TableActionDelete}
                    type="submit"
                />
            </TooltipWrapper>
            <DeleteUserDialog userProfile={userProfile} onSuccess={onSuccess} {...deleteUserDialogProps} />
        </>
    );
};
